import type { Branded } from '@client/new/helpers/types';
import { MediaInput, ReactionParent, ReactionType } from 'generated/graphql';

export { ReactionParent, ReactionType };

export type PostId = Branded<string, 'PostId'>;
export type AuthorId = Branded<number, 'AuthorId'>;

export type MediaItemStatus = 'ready' | 'processing' | 'failed';

export type HeldEdit = 'none' | 'processing' | 'failed';

export type PostStatus = 'published' | 'processing' | 'draft' | 'scheduled';

export type PostMediaItem = {
  type: 'image' | 'video' | 'audio';
  url: string;
  thumbnailUrl: string;
  status: MediaItemStatus;
  input: MediaInput;
};

export type Reaction = {
  type: ReactionType;
  count: number;
  isToggled: boolean;
};

export type Post = {
  id: PostId;
  author: {
    id: AuthorId;
    name: string;
    avatarUrl: string;
    email: string | null;
    marketing: boolean | null;
    isOwn: boolean;
    isCreator: boolean;
    canReceiveDm: boolean;
  };
  createdAt: Date;
  publishedAt: Date | null;
  content: string;
  edited: boolean;
  status: PostStatus;
  media: PostMediaItem[];
  reactions: Reaction[];
  commentCount: number;
  pinned: boolean;
  heldEdit: HeldEdit;
};

export const toPostId = (value: string): PostId => value as PostId;

export const toAuthorId = (value: number): AuthorId => value as AuthorId;
